import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import axios from "axios";

function CombinedCardExample() {
  const [totalOrders, setTotalOrders] = useState(0);
  const [averageOrders, setAverageOrders] = useState(0);
  const [uniqueClientsCount, setUniqueClientsCount] = useState(0);
  const [origineData, setOrigineData] = useState("");
  const [origineData2, setOrigineData2] = useState("");
  const [valoreOrdini, setValoreOrdini] = useState("");
  const [valoreOrdini2, setValoreOrdini2] = useState("");
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [totalOrdered, setTotalOrdered] = useState(0);
  const [averageTotal, setAverageTotal] = useState(0);
  const [totalLastMinute, setTotalLastMinute] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  // 1. Fetch Dati Principali (Ordini, Clienti, Origine)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { totale_ordinato, numero_ordini, origine, clienti } =
          res.data.AR;

        if (totale_ordinato && parseFloat(totale_ordinato) > 0) {
          setTotalOrdered(parseFloat(totale_ordinato));
        }

        if (numero_ordini) {
          setTotalOrders(numero_ordini);
        }

        if (origine && origine.length > 0) {
          let totalNumeroMedioWeb = 0;
          let totalNumeroMedioNoweb = 0;

          origine.forEach((item) => {
            if (item.origine === "web") {
              totalNumeroMedioWeb += parseFloat(item.numero_medio);
            } else if (item.origine === "noweb") {
              totalNumeroMedioNoweb += parseFloat(item.numero_medio);
            }
          });

          setAverageOrders(totalNumeroMedioWeb + totalNumeroMedioNoweb);

          const origineWeb = origine.find((item) => item.origine === "web");
          const origineNoWeb = origine.find((item) => item.origine === "noweb");

          if (origineWeb && origineNoWeb) {
            setValoreOrdini(origineWeb.valore);
            setOrigineData(origineWeb.origine);
            setValoreOrdini2(origineNoWeb.valore);
            setOrigineData2(origineNoWeb.origine);
          }
        }

        if (clienti) {
          let uniqueClients = new Set();
          Object.values(clienti).forEach((clienteArray) => {
            clienteArray.forEach((clienteItem) => {
              uniqueClients.add(clienteItem.cliente);
            });
          });
          setUniqueClientsCount(uniqueClients.size);
        }
      } catch (err) {
        console.error(err);
        setIsError(true);
        setError(err.message);
      }
    };
    fetchData();
  }, []);

  // 2. Fetch Media Semestrale (Valore)
  useEffect(() => {
    const fetchAverageData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { origine } = res.data.AR;

        if (origine && origine.length > 0) {
          const webOrigin = origine.find((item) => item.origine === "web");
          const nowebOrigin = origine.find((item) => item.origine === "noweb");

          const webAverage = webOrigin ? parseFloat(webOrigin.valore_medio) : 0;
          const nowebAverage = nowebOrigin
            ? parseFloat(nowebOrigin.valore_medio)
            : 0;

          setAverageTotal(webAverage + nowebAverage);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchAverageData();
  }, []);

  // 3. Fetch Last Minute (Mancata Vendita)


 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const getTrend = (current, average) => {
    if (!average || average === 0) return null;
    const diff = ((current - average) / average) * 100;
    return (
      <span
        className={`fw-bold d-flex align-items-center gap-1 ${diff < 0 ? "text-danger" : "text-success"}`}
        style={{ fontSize: "0.85rem" }}
      >
        {diff.toFixed(2)}%{" "}
        {diff < 0 ? <FaArrowTrendDown /> : <FaArrowTrendUp />}
      </span>
    );
  };

  return (
    <>
      <Card
        className="card bg-dark ombra ordini-ora card-home hover-effect border-0 am-summary-card am-orders-summary-card"
        style={{ borderRadius: "15px", padding: "1.2rem" }}
        onClick={handleShowModal}
      >
        <Card.Body className=" p-3"
          style={{ borderRadius: "12px", height: "100%" }}
        >
          {/* Header Card */}
          <div className="d-flex justify-content-between align-items-end mb-3 border-bottom border-secondary pb-2 border-opacity-25">
            <div>
              <p
                className="fw-bold mb-0 text-title2 text-uppercase tracking-wider"
                style={{ fontSize: "0.75rem" }}
              >
                Info Ordini
              </p>
              <h3 className="text-light fw-bold mb-0">
                {formatToEuro(totalOrdered)}
              </h3>
            </div>
            <div className="text-end">
              <p className="text-light mb-0" style={{ fontSize: "0.7rem" }}>
                Trend su Media
              </p>
              {getTrend(totalOrdered, averageTotal)}
            </div>
          </div>

          {/* Listato Dati */}
          <div className="d-flex flex-column gap-2">
            <div className="d-flex justify-content-between align-items-center py-1">
              <span className="text-light fw-bold small text-uppercase">
                Media Semestrale
              </span>
              <div className="text-light  fw-bold">
                {formatToEuro(averageTotal)}
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center py-1">
              <span className="text-secondary  fw-bold small text-uppercase">
                Volume Attuale
              </span>
              <div className="text-light small fw-bold">
                {uniqueClientsCount}{" "}
                <span className="fw-normal text-light opacity-50">cli.</span> /{" "}
                {totalOrders}{" "}
                <span className="fw-normal text-secondary opacity-50">
                  ord.
                </span>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center py-1 border-top border-secondary border-opacity-10">
              <span className="text-secondary  fw-bold small text-uppercase">
                Target Ordini
              </span>
              <div className="d-flex align-items-center gap-2 small">
                <span className="text-light">{averageOrders.toFixed(0)}</span>
                {getTrend(totalOrders, averageOrders)}
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center py-1 border-top border-secondary border-opacity-10">
              <span className="text-secondary  fw-bold small text-uppercase">
                Canali
              </span>
              <div className="text-light small" style={{ fontSize: "0.8rem" }}>
                <span className="text-light text-uppercase  fw-bold">{origineData}</span>:{" "}
                {formatToEuro(valoreOrdini)} |{" "}
                <span className="text-secondary text-uppercase  fw-bold">
                  {origineData2}
                </span>
                : {formatToEuro(valoreOrdini2)}
              </div>
            </div>

          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default CombinedCardExample;
